import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import envelopGray from "../../assests/envelopGray.svg";
import clsx from "clsx";
import dashboardTrue from "../../../src/assests/dashboardTrue.svg";
import checkedBlue from "../../../src/assests/checkedBlue.svg";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { User } from "../../providers/AuthProvider";
import { Menu, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import GetUser from "../../utils/getUser";

interface TRenderRow {
  row: User;
  handleMenuToggle: (id: number) => void;
  menuOpen: number;
  tableAction: any[];
  noSpaceAction: boolean;
  rowIndex: number;
}

const RenderRow = ({ row: rowData, tableAction, rowIndex }: TRenderRow) => {
  const user = GetUser();
  const [row] = useState(rowData);

  return (
    <tr className="relative font-medium" key={row?.id}>
      <td className="w-[16%]">
        <p className="text-[16px] font-medium text-text-primary">
          {rowIndex === 0
            ? "🥇"
            : rowIndex === 1
            ? "🥈"
            : rowIndex === 2
            ? "🥉"
            : null}{" "}
          {row.name}
        </p>
      </td>

      <td className="text-light-gray py-3 w-[13%]">
        <p className="text-xs font-medium">{row?.code}</p>
      </td>
      <td className="text-light-gray py-3 w-[20%]">
        <p className="text-xs font-medium">{row?.email}</p>
        <p className="text-xs font-medium">{row?.phone}</p>
      </td>
      <td className="py-3 text-light-gray w-[12%]">
        <p className="text-xs font-medium">
          <span className="font-[600] text-text-primary">
            £{(Number(row?.collections) || 0)?.toFixed(2)}
          </span>
        </p>
      </td>
      <td className="py-3 text-light-gray w-[12%]">
        <p className="text-xs font-medium">
          <span className="font-[600] text-text-primary">
            £{(Number(row?.collectionsPlan) || 0)?.toFixed(2)}
          </span>
        </p>
      </td>

      <td className="py-3 text-light-gray w-[12%]">
        <p className="text-xs font-medium">{row?.type}</p>
      </td>
      <td className="py-3 text-light-gray w-[12%]">
        <div
          className={`flex gap-1 max-w-[100px] h-[26px] pl-2 rounded-2xl items-center border ${
            row.status === "invite-sent"
              ? "bg-overlay-mid border-edge"
              : row.type === "admin" || row?.type === "agent"
              ? "bg-blue/15 border-blue/30"
              : "bg-emerald-500/15 border-emerald-500/30"
          }`}
        >
          <img
            src={
              row.status === "invite-sent"
                ? envelopGray
                : row.type === "admin" || row?.type === "agent"
                ? checkedBlue
                : dashboardTrue
            }
            className={clsx(
              "w-[18px] h-[18px]",
              row?.status === "invite-sent" && "!w-4 !h-3"
            )}
            alt=""
          />
          <p
            className={clsx(
              "text-[11px] font-medium !text-nowrap",
              row?.status === "invite-sent"
                ? "text-light-gray"
                : row?.type === "admin" || row?.type === "agent"
                ? "text-blue"
                : "text-emerald-400"
            )}
          >
            {row?.type}
          </p>
        </div>
      </td>
      {tableAction && user.type !== "agent" && (
        <td className="text-end">
          <Menu as="div" className="relative inline-block text-right">
            <div>
              <Menu.Button>
                <button
                  data-bs-toggle="dropdown"
                  className="cursor-pointer h-[25px] w-[25px] rounded-[50%] flex items-center justify-center"
                >
                  <FontAwesomeIcon
                    icon={faEllipsisV}
                    className="text-light-gray"
                  />
                </button>
              </Menu.Button>
            </div>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <div className="dropdown-menu p-[0] bg-transparent border-none absolute top-[20px] right-0 z-[99999]">
                <div
                  className={clsx(
                    "z-10 py-1 text-light-gray mt-2 w-[auto] min-w-[150px] rounded-xl bg-surface-elevated border border-edge shadow-overlay"
                  )}
                >
                  <div className="py-1">
                    {tableAction.map((action, index) => (
                      <div
                        key={index}
                        className="flex gap-2 px-4 py-2 text-xs text-text-primary items-center font-medium cursor-pointer hover:bg-overlay-hover transition-colors"
                        onClick={() => action.actionHandler(row)}
                      >
                        <FontAwesomeIcon
                          icon={action?.icon}
                          className="text-xs"
                        />
                        {action.name}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Transition>
          </Menu>
        </td>
      )}
    </tr>
  );
};

export default RenderRow;
